import axios from 'axios'
import { API_URL, MASTER_KEY } from '../config'
import { getAltchaToken } from '../managers/captcha-manager'
import { store } from 'store/index'
import { settingsSelectors } from 'store/settings'
import { ApiService } from '@runelab/odin-common'

axios.defaults.baseURL = API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'

axios.interceptors.request.use(async (config) => {
  const state = store.getState()
  const token = settingsSelectors.token(state)

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }

  return config
})

export const masterAxios = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
})

masterAxios.interceptors.request.use(
  async (config) => {
    config.headers['Content-Type'] = 'application/json'
    config.headers.Authorization = `Bearer ${MASTER_KEY}`
    return config
  },
  (err) => Promise.resolve(err),
)

/**
 * This is a separate axios instance for requests that require an altcha token
 */
export const captchaAxios = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
})

captchaAxios.interceptors.request.use(
  async (config) => {
    const altchaToken = await getAltchaToken(masterAxios)
    const state = store.getState()
    const token = settingsSelectors.token(state)
    config.headers['x-altcha-token'] = altchaToken
    config.headers['Content-Type'] = 'application/json'

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (err) => Promise.resolve(err),
)

export const ssoAxios = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
})

export const mainApiService = new ApiService(axios)
export const masterApiService = new ApiService(masterAxios)
